module.exports = __webpack_public_path__ + "static/media/loading.39c43281.gif";